// This file was autogenerated from `packages/roboql/build-support/roboql_fields_gen.py`, and should not be
// modified by hand.

export interface RoboqlFieldDescription {
  aliases: string[];
  comparators: string[] | null;
  default_sort_direction: string;
  detail: string | null;
  documentation: string | null;
  is_default_sort_field: boolean;
  is_sortable: boolean;
  label: string;
  namespace: string;
  sort_nulls_position: string | null;
  value_expression: string | null;
}

export interface MetadataComparators {
  string_metadata: string[];
  numeric_metadata: string[];
  datetime_metadata: string[];
  boolean_metadata: string[];
}

export const roboqlFields: Record<string, RoboqlFieldDescription[]> = {
  datasets: [
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "ISO8601 timestamp when the dataset was created.",
      documentation: null,
      is_default_sort_field: true,
      is_sortable: true,
      label: "created",
      namespace: "datasets",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "User who created the dataset.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "created_by",
      namespace: "datasets",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: ["id"],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "A 'ds_' prefixed unique ID for the dataset.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "dataset_id",
      namespace: "datasets",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Freetext human-readable description of the dataset.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "description",
      namespace: "datasets",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail:
        "The unique ID of the device which created the dataset, or null if created by a human user.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "device_id",
      namespace: "datasets",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "CONTAINS",
        "NOT_CONTAINS",
        "EXISTS",
        "NOT_EXISTS",
        "EQUALS",
        "NOT_EQUALS",
        "LIKE",
        "NOT_LIKE",
        "LESS_THAN_OR_EQUAL",
        "LESS_THAN",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NOT_NULL",
        "IS_NULL",
        "BEGINS_WITH",
      ],
      default_sort_direction: "DESC",
      detail:
        "Custom key-value pairs added by users to categorize the dataset.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "metadata",
      namespace: "datasets",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "ISO8601 timestamp when the dataset was last modified.",
      documentation:
        "A dataset is considered modified when fields such as description, metadata, or tags are updated. Changes due to file uploads are not reflected in this field.",
      is_default_sort_field: false,
      is_sortable: true,
      label: "modified",
      namespace: "datasets",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "User who last modified the dataset.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "modified_by",
      namespace: "datasets",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "A short name for this dataset.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "name",
      namespace: "datasets",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Org which owns the dataset.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "org_id",
      namespace: "datasets",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: ["CONTAINS", "NOT_CONTAINS"],
      default_sort_direction: "DESC",
      detail: "Custom string tags added by users to categorize the dataset.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "tags",
      namespace: "datasets",
      sort_nulls_position: null,
      value_expression: null,
    },
  ],
  files: [
    {
      aliases: ["dataset_id", "collection_id"],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Unique ID of the resource which the file belongs to.",
      documentation:
        "Currently, association ID may be a `ds_` prefixed dataset ID or `cl_` prefixed collection ID.",
      is_default_sort_field: false,
      is_sortable: true,
      label: "association_id",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "ISO8601 timestamp when the file was uploaded.",
      documentation: null,
      is_default_sort_field: true,
      is_sortable: true,
      label: "created",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "User who uploaded the file.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "created_by",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail:
        "Freetext human-readable description of the file and its contents.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "description",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail:
        "The unique ID of the device which uploaded the file, or null if uploaded by a human user.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "device_id",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: ["id", "file_id"],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Unique ID for the file.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "node_id",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "CONTAINS",
        "NOT_CONTAINS",
        "EXISTS",
        "NOT_EXISTS",
        "EQUALS",
        "NOT_EQUALS",
        "LIKE",
        "NOT_LIKE",
        "LESS_THAN_OR_EQUAL",
        "LESS_THAN",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NOT_NULL",
        "IS_NULL",
        "BEGINS_WITH",
      ],
      default_sort_direction: "DESC",
      detail: "Custom key-value pairs added by users to categorize the file.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "metadata",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "ISO8601 timestamp when the file was last modified.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "modified",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "User who last modified the file.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "modified_by",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "The name of the file.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "name",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Org which owns the file.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "org_id",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail:
        "String which describes the client and user which uploaded the file.",
      documentation:
        "This is used to signal that files were written by a specific invocation, by the python SDK, or by something else entirely. Origination is conceptually similar to HTTP User Agents.",
      is_default_sort_field: false,
      is_sortable: false,
      label: "origination",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: ["path"],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail:
        "Full path to the file in the context of its associated resource.",
      documentation:
        "A dataset might have files with relative paths like `top_level_report.pdf` and `raw_images/img123.jpg`. The relative paths can be used to rebuild a flat list of files into a more conventional folder-based file browser view.",
      is_default_sort_field: false,
      is_sortable: true,
      label: "relative_path",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "File size in bytes",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "size",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: ["EQUALS", "NOT_EQUALS"],
      default_sort_direction: "DESC",
      detail: "Lifecycle status of the file.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "status",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: ["CONTAINS", "NOT_CONTAINS"],
      default_sort_direction: "DESC",
      detail: "Custom string tags added by users to categorize the file.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "tags",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Unique ID of the upload transaction responsible for this file.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "upload_id",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "The URI of the file.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "uri",
      namespace: "files",
      sort_nulls_position: null,
      value_expression: null,
    },
  ],
  topics: [
    {
      aliases: ["file_id"],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Unique ID of the resource which the topic belongs to.",
      documentation: "Currently, association ID will always be a file ID.",
      is_default_sort_field: false,
      is_sortable: true,
      label: "association_id",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Type of the resource which the topic belongs to.",
      documentation: "Currently, association type will always be 'file'.",
      is_default_sort_field: false,
      is_sortable: true,
      label: "association_type",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "ISO8601 timestamp when the topic was created.",
      documentation: null,
      is_default_sort_field: true,
      is_sortable: true,
      label: "created",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "User who created the topic.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "created_by",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Epoch nanosecond timestamp of the last message in the topic.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "end_time",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "The number of messages in the topic.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "message_count",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: ["fields"],
      comparators: null,
      default_sort_direction: "DESC",
      detail:
        "Reference a single property within a complex topic, e.g. `sensor.imu.x`.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "msgpaths",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "CONTAINS",
        "NOT_CONTAINS",
        "EXISTS",
        "NOT_EXISTS",
        "EQUALS",
        "NOT_EQUALS",
        "LIKE",
        "NOT_LIKE",
        "LESS_THAN_OR_EQUAL",
        "LESS_THAN",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NOT_NULL",
        "IS_NULL",
        "BEGINS_WITH",
      ],
      default_sort_direction: "DESC",
      detail: "Custom key-value pairs added by users to categorize the topic.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "metadata",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "ISO8601 timestamp when the topic was last modified.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "modified",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "User who last modified the topic.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "modified_by",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Org which owns the topic.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "org_id",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Deterministic checksum version of a schema.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "schema_checksum",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Name of the schema used to serialize messages in the topic.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "schema_name",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Monotonically increasing version of a schema.",
      documentation:
        "This is useful for seeing how a schema with a fixed name has evolved over time.",
      is_default_sort_field: false,
      is_sortable: false,
      label: "schema_version",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Epoch nanosecond timestamp of the first message in the topic.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "start_time",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: ["id"],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Unique numeric ID for the topic.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "topic_id",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: ["name"],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Name for the topic.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "topic_name",
      namespace: "topics",
      sort_nulls_position: null,
      value_expression: null,
    },
  ],
  topic_message_paths: [
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail:
        "Well-known (and simplified) data types, normalized across frameworks/technologies.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "canonical_data_type",
      namespace: "topic_message_paths",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "ISO8601 timestamp when the message path was created.",
      documentation: null,
      is_default_sort_field: true,
      is_sortable: true,
      label: "created",
      namespace: "topic_message_paths",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "User who created the message path.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "created_by",
      namespace: "topic_message_paths",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail:
        "'Native'/framework-specific data type of the attribute at this path. E.g. 'float32', 'uint8[]', 'geometry_msgs/Pose', 'string'.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "data_type",
      namespace: "topic_message_paths",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: ["name", "path", "field"],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Dot-delimited path to an attribute within a topic datum record.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "message_path",
      namespace: "topic_message_paths",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "CONTAINS",
        "NOT_CONTAINS",
        "EXISTS",
        "NOT_EXISTS",
        "EQUALS",
        "NOT_EQUALS",
        "LIKE",
        "NOT_LIKE",
        "LESS_THAN_OR_EQUAL",
        "LESS_THAN",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NOT_NULL",
        "IS_NULL",
        "BEGINS_WITH",
      ],
      default_sort_direction: "DESC",
      detail:
        "Custom key-value pairs added by users to categorize the topic.msgpath.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "metadata",
      namespace: "topic_message_paths",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "ISO8601 timestamp when the message path was last modified.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "modified",
      namespace: "topic_message_paths",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "User who last modified the message path.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "modified_by",
      namespace: "topic_message_paths",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: ["EQUALS", "NOT_EQUALS"],
      default_sort_direction: "DESC",
      detail: "Org which owns the topic with this message path.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "org_id",
      namespace: "topic_message_paths",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail:
        "Unique numeric ID for the topic to which this message path is associated.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "topic_id",
      namespace: "topic_message_paths",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: ["id"],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Unique numeric ID for the message path.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "message_path_id",
      namespace: "topic_message_paths",
      sort_nulls_position: null,
      value_expression: null,
    },
  ],
  events: [
    {
      aliases: ["id"],
      comparators: ["EQUALS", "NOT_EQUALS"],
      default_sort_direction: "DESC",
      detail: "Unique ID for the event.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "event_id",
      namespace: "events",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: ["event_name"],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Friendly name for the event.",
      documentation:
        "The event name is meant to be a quick reminder of the event's type or significance.",
      is_default_sort_field: false,
      is_sortable: true,
      label: "name",
      namespace: "events",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Free-text description of the event.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "description",
      namespace: "events",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "UTC timestamp of the start of the event.",
      documentation:
        "The timestamp can be provided as Unix epoch nanoseconds, or as an ISO8601-formatted string.",
      is_default_sort_field: false,
      is_sortable: true,
      label: "start_time",
      namespace: "events",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "UTC timestamp of the end of the event.",
      documentation:
        "The timestamp can be provided as Unix epoch nanoseconds, or as an ISO8601-formatted string.",
      is_default_sort_field: false,
      is_sortable: true,
      label: "end_time",
      namespace: "events",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: ["CONTAINS", "NOT_CONTAINS"],
      default_sort_direction: "DESC",
      detail: "Custom string tags added by users to categorize the event.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "tags",
      namespace: "events",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "CONTAINS",
        "NOT_CONTAINS",
        "EXISTS",
        "NOT_EXISTS",
        "EQUALS",
        "NOT_EQUALS",
        "LIKE",
        "NOT_LIKE",
        "LESS_THAN_OR_EQUAL",
        "LESS_THAN",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NOT_NULL",
        "IS_NULL",
        "BEGINS_WITH",
      ],
      default_sort_direction: "DESC",
      detail: "Custom key-value pairs added by users to categorize the event.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "metadata",
      namespace: "events",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: ["created_at"],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "ISO8601 timestamp when the event was created.",
      documentation: null,
      is_default_sort_field: true,
      is_sortable: true,
      label: "created",
      namespace: "events",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: ["modified_at", "updated_at"],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "ISO8601 timestamp when the event was last modified.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "modified",
      namespace: "events",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "User who created the event.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "created_by",
      namespace: "events",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "User who last modified the event.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "modified_by",
      namespace: "events",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: ["EQUALS", "NOT_EQUALS"],
      default_sort_direction: "DESC",
      detail: "Org which owns the event.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "org_id",
      namespace: "events",
      sort_nulls_position: null,
      value_expression: null,
    },
  ],
  sessions: [
    {
      aliases: ["id"],
      comparators: ["EQUALS", "NOT_EQUALS"],
      default_sort_direction: "DESC",
      detail: "Unique identifier of the session.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "session_id",
      namespace: "sessions",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "Display name of the session.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "name",
      namespace: "sessions",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: ["start_time"],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail:
        "Inclusive lower bound of the session's recorded time window, in nanoseconds since the Unix epoch.",
      documentation:
        "May be referenced in a query by the alias `start_time`. The value supplied in a filter may be any shape `roboto.time.Time` accepts: an integer (interpreted as epoch nanoseconds), a float or Decimal (interpreted as epoch seconds), an ISO8601 string, a `<sec>.<nsec>` string, or a tz-aware datetime; the server normalizes any of these to epoch-ns via `roboto.time.to_epoch_nanoseconds` before the comparison runs. An empty session has no recorded window, so this field is NULL on that session and any concrete comparison (`<`, `>=`, `=`, ...) excludes it; use `IS_NULL` to surface those sessions explicitly.",
      is_default_sort_field: true,
      is_sortable: true,
      label: "min_timestamp_ns",
      namespace: "sessions",
      sort_nulls_position: "last",
      value_expression: null,
    },
    {
      aliases: ["end_time"],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail:
        "Inclusive upper bound of the session's recorded time window, in nanoseconds since the Unix epoch.",
      documentation:
        "May be referenced in a query by the alias `end_time`. The value supplied in a filter may be any shape `roboto.time.Time` accepts: an integer (interpreted as epoch nanoseconds), a float or Decimal (interpreted as epoch seconds), an ISO8601 string, a `<sec>.<nsec>` string, or a tz-aware datetime; the server normalizes any of these to epoch-ns via `roboto.time.to_epoch_nanoseconds` before the comparison runs. An empty session has no recorded window, so this field is NULL on that session and any concrete comparison (`<`, `>=`, `=`, ...) excludes it; use `IS_NULL` to surface those sessions explicitly.",
      is_default_sort_field: false,
      is_sortable: false,
      label: "max_timestamp_ns",
      namespace: "sessions",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail:
        "Length of the session's recorded time window, in nanoseconds. Synthetic, computed as max_timestamp_ns - min_timestamp_ns.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: true,
      label: "duration",
      namespace: "sessions",
      sort_nulls_position: "last",
      value_expression: "(max_timestamp_ns - min_timestamp_ns)",
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "ISO8601 timestamp when the session was created.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "created",
      namespace: "sessions",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "User who created the session.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "created_by",
      namespace: "sessions",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "LESS_THAN",
        "LESS_THAN_OR_EQUAL",
        "GREATER_THAN",
        "GREATER_THAN_OR_EQUAL",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "ISO8601 timestamp when the session was last modified.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "modified",
      namespace: "sessions",
      sort_nulls_position: null,
      value_expression: null,
    },
    {
      aliases: [],
      comparators: [
        "EQUALS",
        "NOT_EQUALS",
        "CONTAINS",
        "NOT_CONTAINS",
        "LIKE",
        "NOT_LIKE",
        "IS_NULL",
        "IS_NOT_NULL",
      ],
      default_sort_direction: "DESC",
      detail: "User who last modified the session.",
      documentation: null,
      is_default_sort_field: false,
      is_sortable: false,
      label: "modified_by",
      namespace: "sessions",
      sort_nulls_position: null,
      value_expression: null,
    },
  ],
};
export const roboqlMetadataComparators: MetadataComparators = {
  string_metadata: [
    "EQUALS",
    "NOT_EQUALS",
    "CONTAINS",
    "NOT_CONTAINS",
    "LIKE",
    "NOT_LIKE",
    "IS_NULL",
    "IS_NOT_NULL",
  ],
  numeric_metadata: [
    "EQUALS",
    "NOT_EQUALS",
    "LESS_THAN",
    "LESS_THAN_OR_EQUAL",
    "GREATER_THAN",
    "GREATER_THAN_OR_EQUAL",
    "IS_NULL",
    "IS_NOT_NULL",
  ],
  datetime_metadata: [
    "EQUALS",
    "NOT_EQUALS",
    "LESS_THAN",
    "LESS_THAN_OR_EQUAL",
    "GREATER_THAN",
    "GREATER_THAN_OR_EQUAL",
    "IS_NULL",
    "IS_NOT_NULL",
  ],
  boolean_metadata: ["EQUALS", "NOT_EQUALS", "EXISTS", "NOT_EXISTS"],
};
